import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-district-columbia-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./district-columbia-state-form.component.html",
  styleUrl: "./district-columbia-state-form.component.scss",
})
export class DistrictColumbiaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
